var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "block-with-checks d-md-none" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-4 d-flex align-items-center" }, [
            _c("div", { staticClass: "check-item" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../img/icon/submit.svg"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "minimum" }, [_vm._v("156 Elbolag")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-4 d-flex align-items-center" }, [
            _c("div", { staticClass: "check-item" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../img/icon/submit.svg"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "minimum" }, [_vm._v("Prisgaranti")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-4 d-flex align-items-center" }, [
            _c("div", { staticClass: "check-item" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../img/icon/submit.svg"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "minimum" }, [_vm._v("Kostnadsfritt")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }